import { ColorProps } from 'styled-system';
import { Box } from '../Box';
import { icons } from './config';

export type IconKeys = keyof typeof icons;

type Props = {
  name: IconKeys;
  width?: number | string;
  height?: number | string;
  color?: ColorProps['color'] & string;
};

export const Icon = ({ name, color, width = 24, height = 24 }: Props) => {
  const IconName = icons[name];

  return (
    <Box color={color} lineHeight={0}>
      <IconName width={width} height={height} />
    </Box>
  );
};
